import type { FinancialMetricMode } from '../model/types'

const METRIC_MODE_TRANSLATION_KEYS: Record<FinancialMetricMode, string> = {
  tnet: 'jbp-h2-review-fin-sob-metric-mode-tnet',
  net: 'jbp-h2-review-fin-sob-metric-mode-net',
  ndp: 'jbp-h2-review-fin-sob-metric-mode-ndp',
}

export const FINANCIAL_METRIC_MODE_OPTIONS: FinancialMetricMode[] = ['tnet', 'net', 'ndp']

export const getMetricModeTranslationKey = (metricMode: FinancialMetricMode) =>
  METRIC_MODE_TRANSLATION_KEYS[metricMode]
